import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';

/**
 * アプリ本体の 3 カラムレイアウト（ヘッダー + サイドバー + 本体）。
 * RequireAuth で認証済みユーザーのみがレンダリングされる。
 */
export function AppLayout() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <AppSidebar />
      <div className="flex flex-1 flex-col">
        <AppHeader />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
